import { useTranslation } from 'react-i18next';
import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { ApiError } from 'dd-client/site/common/types';
import { hasPromotions } from 'dd-client/site/common/utils/features';
import { QUERY } from 'dd-client/site/common/utils/query/query';
import { Promotions } from './types';

const usePromotions = (): UseQueryResult<Promotions, ApiError> => {
  const { i18n: { language } } = useTranslation();

  return useQuery({
    enabled: hasPromotions,
    queryFn: QUERY.promotions.queryFunction,
    queryKey: [QUERY.promotions.queryName, language],
  });
};

export {
  usePromotions,
};

